import { render, staticRenderFns } from "./PageTurner.vue?vue&type=template&id=097cd47b&scoped=true"
import script from "./PageTurner.vue?vue&type=script&lang=js"
export * from "./PageTurner.vue?vue&type=script&lang=js"
import style0 from "./PageTurner.vue?vue&type=style&index=0&id=097cd47b&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097cd47b",
  null
  
)

export default component.exports